export default "__VITE_ASSET__qrLxTaqS__"